import React, { Component } from 'react';
import LaudosAnterioresPage from './laudos-anteriores.page';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import WebapiCommon from '@common/util/webapi.common';
import * as editorUtil from '../../../../pages/laudo/editor/editor.util';
import * as commomactions from '../../common.action';

class LaudosAnterioresContainer extends Component {
  constructor() {
    super();
    this.state = {
      laudos: undefined,
      active: undefined,
      laudo: undefined,
    };
  }

  componentDidMount() {
    this.props.commomactions.showFadeCarregando(true);
    WebapiCommon.getLaudosAnteriores(this.props.detalhes.prontuario).then(
      (laudos) => {
        this.setState({
          laudos: laudos,
        });
        this.props.commomactions.showFadeCarregando(false);
      }
    );
  }

  componentWillUnmount() {
    this.voltarLaudoDoExame();
    this.setState({
      laudos: undefined,
      active: undefined,
    });
    this.props.commomactions.alterarAutoSaveTextolaudo(true);
  }

  render() {
    return (
      <LaudosAnterioresPage
        laudos={this.state.laudos}
        active={this.state.active}
        alturaEditor={this.getAltura.bind(this)}
        getLaudoFinal={this.getLaudoFinal.bind(this)}
        voltarLaudoDoExame={this.voltarLaudoDoExame.bind(this)}
        altura={this.props.altura}
        plainTextLaudo={this.props.plainTextLaudo}
        laudo={this.state.laudo}
        commonActions={this.props.commomactions}
      />
    );
  }

  getAltura = () => {
    return (
      document.getElementById('container-editor') &&
      document.getElementById('container-editor').style.height
    );
  };

  voltarLaudoDoExame() {
    this.props.commomactions.preencherPlainText(undefined);
    this.props.commomactions.preencherDraggablePanelContent(
      undefined,
      undefined
    );
  }

  getLaudoFinal(laudo) {
    this.props.commomactions.showFadeCarregando(true);
    try {
      this.setState({ laudo: laudo });
      WebapiCommon.getLaudoFinalStr(laudo.laudo).then((final) => {
        this.props.commomactions.preencherPlainText(final.data.plainText);
			  this.props.commomactions.showFadeCarregando(false);
        this.props.commomactions.preencherDraggablePanelContent(
          undefined,
          undefined
        );
      });
    } catch (error) {
      this.props.commomactions.showAlerta('erro', error.message, 2000, '550px');
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    commomactions: bindActionCreators(commomactions, dispatch),
  };
};

const mapStateToProps = (state) => {
  return {
    detalhes: state.commonReducer.detalhes,
    plainTextLaudo: state.commonReducer.plainTextLaudo,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LaudosAnterioresContainer);



// WEBPACK FOOTER //
// ./src/app/common/tabs/anteriores/laudos-anteriores.container.js